import { Dispatch, SetStateAction, useState } from 'react';
import { Desktop, Mobile } from '../../../App';

import { Hub } from '../Hub/Hub';

import {
  BACKOFFICE_NAME,
  BACKOFFICE_NAME_CAPS,
  formatUSD,
  SendingTokenType,
  tokens,
  USDT
} from '../../../helpers/helperFunctions';
import { H3, H4, P1, P2, P3 } from '../../../styles/FontStyles';
import { Button, Flexed } from '../../../styles/GlobalComponents';
import { color } from '../../../styles/GlobalStyles';

import { Checkbox } from '../Checkbox/Checkbox';

import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { addHub } from '../../../views/Marketplace/Marketplace.actions';
import { buyVirtualOffice } from '../../../views/Settings/Settings.actions';
import { VirtualOfficeSubscriptionStyled } from './VirtualOfficeSubscription.styled';

import { useAppSelector } from '../../../app/hooks';
import { SelectedUSDT } from '../../../styles/GlobalComponents';
import { WalletsType } from '../../../types/types';
import { CheckText } from '../CheckText';
import { SelectNetwork } from '../SelectNetwork/SelectNetwork';
import { SelectToken } from '../SelectNetwork/SelectToken';
import { TokenCurrencyType } from '../../../views/Marketplace/Maeketplace.types';

interface VirtualOfficeSelectedOrder {
  step: number;
  setStep: Dispatch<SetStateAction<number>>;
  selected: any;
  selectedHub?: number;
  setSelectedToken: Dispatch<SetStateAction<any>>;
  selectedToken: any;
}

export const VirtualOfficeSelectedOrder = ({
  step,
  setStep,
  selected,
  selectedHub,
  selectedToken,
  setSelectedToken
}: VirtualOfficeSelectedOrder) => {
  const { t } = useTranslation('packages');
  const { t: translate } = useTranslation('marketplace');

  const [selectedNetwork, setSelectedNetwork] = useState<WalletsType | null>(
    null
  );
  const [checkbox, setCheckbox] = useState(false);

  const { hubs } = useAppSelector((state) => state.marketplace);

  const hub = hubs?.find((i) => i.id === selectedHub);

  const dispatch = useDispatch();

  return (
    <div>
      {!selectedHub && (
        <>
          <P1 bold mb={'20'}>
            {t('payment_method.selected_subscription', {
              BACKOFFICE_NAME_CAPS
            })}
          </P1>
          <VirtualOfficeSubscriptionStyled>
            <Desktop>
              <div>
                <Flexed between>
                  <Flexed center>
                    <Checkbox margin='0 12px 0 0' size={'38'} checked={true} />
                    <div>
                      <P1 caps bold>
                        {selected.title}
                      </P1>
                    </div>
                  </Flexed>
                  <div style={{ textAlign: 'end' }}>
                    <H3>${selected.price}</H3>
                  </div>
                </Flexed>
              </div>
            </Desktop>
            <Mobile>
              <div>
                <Flexed between center>
                  <Flexed center>
                    <Checkbox margin='0 12px 0 0' size={'38'} checked={true} />
                    <div>
                      <H4>{selected.title}</H4>
                    </div>
                  </Flexed>
                  <div style={{ textAlign: 'end' }}>
                    <H4>${selected.price}</H4>
                  </div>
                </Flexed>
              </div>
            </Mobile>
          </VirtualOfficeSubscriptionStyled>
        </>
      )}
      {selectedHub && (
        <P2 mb={'20'} bold>
          {t('payment_method.selected_nft')}
        </P2>
      )}

      {selectedHub &&
        hubs.map(
          ({
            id,
            image,
            title,
            price,
            weeklyCap,
            dobuleTradingBinaries,
            limitedQuantity
          }) => {
            if (id === selectedHub) {
              return (
                <Hub
                  key={id}
                  condensed
                  image={image}
                  title={title}
                  price={hub!.price ? price + selected.price : price}
                  weeklyCap={weeklyCap}
                  dobuleTradingBinaries={dobuleTradingBinaries}
                  includesSubscription={selected.access}
                  limitedQuantity={limitedQuantity}
                />
              );
            } else return null;
          }
        )}
      <P3 mb='8' mt='40'>
        {t('payment_method.select_usdt_network', { BACKOFFICE_NAME })}
      </P3>

      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('payment_method.payment_ammount')}
      </P3>

      <SelectedUSDT>
        {selectedHub
          ? formatUSD(selected.price + hub!.price)
          : formatUSD(selected.price)}
        <b>{USDT}</b>
      </SelectedUSDT>

      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {t('payment_method.select')} {t('payment_method.network')}
      </P3>

      <SelectNetwork
        onChange={(n) => setSelectedNetwork(n)}
        value={selectedNetwork}
      />

      <P3 bold mb='8' mt='20' color={color.colors.neutral900}>
        {translate('select_token')}
      </P3>

      <SelectToken
        onChange={(token) => {
          setSelectedToken(token);

          // if (token.index === Tokens.TETHER) {
          //   if (calculatedPrice) {
          //     setUsdt(calculatedPrice);
          //   } else {
          //     setUsdt(amountToPay.toString());
          //   }

          //   setUsdc('');
          // } else {
          //   if (calculatedPrice) {
          //     setUsdc(calculatedPrice);
          //   } else {
          //     setUsdc(amountToPay.toString());
          //   }
          //   setUsdt('');
          // }
        }}
        value={selectedToken}
      />

      {selectedNetwork && (
        <P3 bold mb='25' color={color.colors.error500}>
          <SendingTokenType network={selectedNetwork?.networkType} />
        </P3>
      )}

      {selectedNetwork && (
        <CheckText
          checked={checkbox}
          onClick={() => setCheckbox(!checkbox)}
          text={t('payment_method.i_understand')}
        />
      )}

      <Button
        mt='20'
        disabled={!checkbox || !selectedToken}
        onClick={() => {
          if (selectedHub) {
            dispatch(
              addHub({
                packageId: selectedHub,
                currencyType:
                  selectedToken.index === tokens[0].index
                    ? TokenCurrencyType.TETHER
                    : TokenCurrencyType.USDC,
                networkType: selectedNetwork!.networkType,
                licenceId: selected.id,
                userDiscountCodeId: null,
                step,
                setStep
              })
            );
          } else {
            dispatch(
              buyVirtualOffice({
                licenceId: selected.id,
                networkType: selectedNetwork!.networkType,
                currencyType:
                  selectedToken.index === tokens[0].index
                    ? TokenCurrencyType.TETHER
                    : TokenCurrencyType.USDC,
                step,
                setStep
              })
            );
          }
        }}>
        {t('payment_method.create_order')}
      </Button>
    </div>
  );
};
